<template>
  <smart-church-layout page="Add First Timers">
    <v-snackbar
      v-model="snackbar.status"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      >{{ snackbar.msg }}</v-snackbar
    >
    <v-overlay :opacity="0.4" :value="overlay">
      <v-progress-circular indeterminate size="64"> </v-progress-circular>
    </v-overlay>
    <!-- <skeletonLoader v-if="overlay" class="mt-7" /> -->

    <v-dialog
      v-model="dialog"
      max-width="900"
      height="700"
      overlay
      retain-focus
      transition="dialog-bottom-transition"
    >
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Open Dialog
        </v-btn>
      </template> -->
      <v-card class="p-1 p-lg-3">
        <div class="d-flex justify-content-end">
          <v-btn icon dark @click="dialog = false" color="black" class="p-3">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-row
          align="center"
          justify="center"
          class="mt-0 mt-lg-5 w-90 mx-auto"
        >
          <v-col cols="12">
            <a href="https://smartchurch.ng/" target="_blank">
              <v-img
                src="@/assets/smartchurch-logo.png"
                max-height="180"
                max-width="180"
                class="d-block mx-auto"
              ></v-img>
            </a>
          </v-col>
          <v-col cols="12" lg="7">
            <v-form class="p-4" @submit.prevent="addFeedback" ref="ratingForm">
              <v-row>
                <v-col cols="12">
                  <h3 class="text-h4 text-bold text-center">
                    What is your rating?
                  </h3>
                  <p class="text-secondary fs-5 text-center">
                    Please drop a comment or remark about your <br />
                    experience using SmartChurch
                  </p>
                  <div class="w-75 mx-auto m-2">
                    <star-rating
                      animate
                      :glow="glow"
                      :show-rating="showNumber"
                      :star-size="starSize"
                      v-model="feedBack.rating"
                      class="d-flex justify-content-center"
                    />
                  </div>
                </v-col>
                <v-col cols="12" class="mt-5">
                  <v-textarea
                    outlined
                    v-model="feedBack.message"
                    hint="Kindly complete the comment section"
                    required
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-btn
                type="submit"
                color="primary white--text"
                block
                class="fw-bold"
                :loading="isSubmitted"
                :disabled="isSubmitted"
                >Submit</v-btn
              >
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-container fluid class="my-8">
      <div class="d-flex justify-space-between">
        <v-btn
          class="bg-transparent ms-7 mt-5"
          small
          :to="{ name: 'AdminFirstTimers' }"
          ><v-icon>mdi-arrow-u-left-top</v-icon></v-btn
        >
      </div>

      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="8">
          <div class="alert alert-danger my-3" v-if="mountedError">
            Data could not be loaded: {{ mountedError }}
            <v-btn
              color="primary white--text"
              :loading="isLoading"
              @click="initAddFirstTimers"
            >
              Fetch again
            </v-btn>
          </div>

          <v-card
            class="d-flex justify-center mt-12 rounded-lg text-capitalize"
          >
            <v-form
              class="my-6 pa-13"
              ref="form"
              @submit.prevent="addFirstTimers"
            >
              <h2
                class="primary--text d-flex justify-center my-4 font-weight-bold"
              >
                Add First Timer
              </h2>

              <v-row class="mt-6">
                <v-col cols="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    label="Date"
                    type="date"
                    id="Date"
                    v-model="add_first_timers.attendance_date"
                    :error-messages="add_first_timers.attendance_date"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="First Name"
                    id="fname"
                    v-model="add_first_timers.first_name"
                    :error-messages="add_first_timers_errors.first_name"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="Last Name"
                    id="lname"
                    v-model="add_first_timers.last_name"
                    :error-messages="add_first_timers_errors.last_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="add_first_timers.branch_id"
                    :items="branches"
                    dense
                    label="Branch"
                    id="branch_id"
                    item-value="id"
                    outlined
                    item-text="name"
                    :error-messages="add_first_timers_errors.branch_id"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="Email"
                    id="email"
                    v-model="add_first_timers.email"
                    :error-messages="add_first_timers_errors.email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    outlined
                    dense
                    label="Gender"
                    id="sex"
                    :items="items"
                    v-model="add_first_timers.sex"
                    :error-messages="add_first_timers_errors.sex"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    type="number"
                    outlined
                    dense
                    label="Phone Number"
                    id="phone"
                    v-model="add_first_timers.phone"
                    :error-messages="add_first_timers_errors.phone"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-text-field
                    type="date"
                    outlined
                    dense
                    label="Date Of Birth"
                    v-model="add_first_timers.date_of_birth"
                    :error-messages="add_first_timers_errors.date_of_birth"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    label="Occupation"
                    id="Occupation"
                    v-model="add_first_timers.occupation"
                    :error-messages="add_first_timers_errors.occupation"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="marital_status"
                    outlined
                    dense
                    label="Marital Status"
                    id="marital status"
                    v-model="add_first_timers.marital_status"
                    :error-messages="add_first_timers_errors.marital_status"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    :items="employment"
                    id="Employment Status"
                    label="Employment status"
                    v-model="add_first_timers.employment_status"
                    :error-messages="add_first_timers_errors.employment_status"
                    outlined
                    dense
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    outlined
                    label="Residential Address"
                    v-model="add_first_timers.address"
                    :error-messages="add_first_timers_errors.address"
                  ></v-textarea>
                </v-col>

                <v-col col="12" md="12">
                  <v-switch
                    v-model="add_first_timers.under_forty"
                    label="Are you Under the age of 40"
                  ></v-switch>
                </v-col>

                <div
                  class="alert alert-danger mt-5 text-center"
                  v-if="add_first_timers_errors.length > 1"
                >
                  {{ add_first_timers_errors }}
                </div>

                <!-- <div>
                  <v-btn @click="uploadPicture" depressed color="primary white--text" class="mb-2">
                  upload
                </v-btn>
                </div> -->
              </v-row>
              <v-btn
                type="submit"
                depressed
                block
                :loading="isSubmitted"
                :disabled="isSubmitted"
                color="primary white--text"
                >Add</v-btn
              >
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </smart-church-layout>
</template>
<script>
import SmartChurchLayout from "../../components/Layouts/SmartChurchLayout.vue";
import { catchAxiosExceptions } from "../../__helpers/handelExceptions";

import StarRating from "vue-star-rating";

export default {
  components: { SmartChurchLayout, StarRating },

  data() {
    return {
      items: ["male", "female"],
      status: ["Active", "Inactive"],
      employment: ["employed", "unemployed"],
      marital_status: ["single", "married"],

      add_first_timers: {
        attendance_date: "",
        first_name: "",
        last_name: "",
        branch_id: "",
        email: "",
        phone: "",
        address: "",
        occupation: "",
        employment_status: "",
        sex: "",
        marital_status: "",
        date_of_birth: "",
        under_forty: true,
        status: "",
      },

      overlay: true,

      branches: [],
      add_first_timers_errors: {},

      isLoading: false,
      mountedError: null,

      isSubmitted: false,

      dialog: false,

      showNumber: false,
      starSize: 45,
      glow: 4,

      feedBack: {
        rating: 0,
        message: "",
      },

      snackbar: {
        status: false,
        msg: "",
        color: "",
        timeout: 3000,
      },
    };
  },

  methods: {
    async initAddFirstTimers() {
      this.isLoading = true;

      try {
        const user = this.$store.state.userDetail.user;
        this.branches = user.branches;
        this.isLoading = false;

        this.overlay = false;
      } catch (error) {
        this.isLoading = false;
        this.overlay = false;

        catchAxiosExceptions(error);
      }
    },

    addFeedback() {
      this.isSubmitted = true;

      this.$http
        .post("feedback", this.feedBack)
        .then((response) => {
          // console.log(response.data.message);
          this.isSubmitted = false;
          this.dialog = false;
          this.snackbar.status = true;
          this.snackbar.msg = response.data.message;
          this.snackbar.color = "green";
          this.$refs.ratingForm.reset();
          this.feedBack.rating = 0;
          localStorage.setItem("checkedRatingForm", true);
        })
        .catch((error) => {
          // console.log(error);
          this.isSubmitted = false;

          this.snackbar.status = true;
          this.snackbar.msg = error.response.data.message;
          this.snackbar.color = "red";
        });
    },

    addFirstTimers() {
      this.add_first_timers_errors = "";

      this.isSubmitted = true;

      this.$http
        .post("admin/firstTimers", this.add_first_timers)
        .then((response) => {
          this.snackbar.status = true;
          this.snackbar.msg = response.data.message;
          this.snackbar.color = "green";

          this.isSubmitted = false;
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          this.$refs.form.reset();

          if (!localStorage.getItem("checkedRatingForm")) {
            this.dialog = true;
          }
        })
        .catch((error) => {
          this.snackbar.status = true;
          this.snackbar.msg = error.response.data.message;
          this.snackbar.color = "red";

          this.add_first_timers_errors = error.response.data.errors;

          this.isSubmitted = false;

          catchAxiosExceptions(error);
        });
    },
  },

  mounted() {
    this.initAddFirstTimers();
  },
};
</script>

<style scoped>
label {
  color: #c73438;
  font-size: 16px !important;
  margin-bottom: 0.5em !important;
}
.v-icon {
  color: #c73438;
}
.v-text-field--outlined >>> fieldset {
  border-color: rgba(204, 49, 10, 0.986);
}

.v-text-field::-moz-focus-inner {
  background-color: red !important;
}
.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot:focus {
  background: #eedddd !important;
}
.img-content {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
</style>
